import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
const globalControlsContext = createContext({
  controls: {
    bottom: [],
    left: [],
    right: [],
    top: []
  }
});
const globalControlsApiContext = createContext({
  registerControl: () => () => {
  }
});
function GlobalControlsProvider(props) {
  const { children } = props;
  const [controls, setControls] = useState({
    bottom: [],
    left: [],
    right: [],
    top: []
  });
  const [api] = useState(() => ({
    registerControl: (placement, ...elements) => {
      setControls((prev) => {
        const next = { ...prev };
        next[placement] = [...next[placement], ...elements];
        return next;
      });
      return () => {
        setControls((prev) => {
          const next = { ...prev };
          next[placement] = next[placement].filter((item) => !elements.includes(item));
          return next;
        });
      };
    }
  }));
  return /* @__PURE__ */ jsx(globalControlsApiContext.Provider, { value: api, children: /* @__PURE__ */ jsx(globalControlsContext.Provider, { value: { controls }, children }) });
}
function useGlobalControls() {
  return useContext(globalControlsContext);
}
function useGlobalControlsApi() {
  return useContext(globalControlsApiContext);
}
export {
  GlobalControlsProvider,
  useGlobalControls,
  useGlobalControlsApi
};
//# sourceMappingURL=GlobalControlsProvider.js.map
